const ar = {
    ...frappe.boot.__messages,
    "Test": "تجربة",
    "About UNIX": "عن يونكس",
    "Profile": "الملف الشخصي",
    "Update Profile": "تحديث الملف الشخصي",
    "About Me": "عني",
    "Edit Cover Photo": "تعديل صورة الغلاف",
    "Upload Photo": "تحميل صورة",
    "Drag and drop files here or upload from": "اسحب وأسقط الملفات هنا أو قم بالتحميل من",
    "My Device": "جهازي",
    "Upload": "تحميل",
    "Set all private": "تعيين الجميع كخاص",
    "Work Experience": "خبرة العمل",
    "LinkedIn URL": "رابط LinkedIn",
    "Current Password": "كلمة المرور الحالية",
    "New Password": "كلمة المرور الجديدة",
    "Re-type New Password": "أعد كتابة كلمة المرور الجديدة",
    "Set New Password": "تعيين كلمة مرور جديدة",
    "Welcome": "مرحبا",
    "Switch to Desk": "إدارة النظام",
    "My Profile": "ملفي الشخصي",
    "Enrolled Courses": "الدورات المسجلة",
    "Reviews": "المراجعات",
    "Orders History": "سجل الطلبات",
    "My Quiz": "اختباراتي",
    "Discuss": "النقاش",
    "Certificates": "الشهادات",
    "Settings": "الإعدادات",
    "Logout": "تسجيل خروج",
    "User": "المستخدم",
    "Registration Date": "تاريخ التسجيل",
    "Skills": "المهارات",
    "Biography": "السيرة الذاتية",
    "Education Details": "تفاصيل التعليم",
    "Certification": "الشهادة",
    "Certifications": "الشهادات",
    "Start Date": "تاريخ البدء",
    "End Date": "تاريخ الانتهاء",
    "Grade": "الدرجة",
    "Completed": "المكتملة",
    "Resources": "المصادر",
    "Lessons": "الدروس",
    "View Course": "عرض الدورة",
    "Not Reviews Found": "لم يتم العثور على مراجعات",
    "Course Title": "عنوان الدورة",
    "Feedback": "التعليق",
    "Online Payments": "المدفوعات عبر الإنترنت",
    "Offline Payments": "المدفوعات داخل المكتب",
    "Order ID": "رقم الطلب",
    "Program": "البرنامج",
    "Course": "الدورة",
    "Date": "التاريخ",
    "Price": "السعر",
    "Status": "الحالة",
    "Not Payments Found": "لم يتم العثور على مدفوعات",
    "On Hold": "في الانتظار",
    "Success": "نجاح",
    "Completed Quiz": "الاختبارات المكتملة",
    "Upcoming Quiz": "الاختبارات القادمة",
    "Quiz Info": "معلومات الاختبار",
    "Start At": "البدء في",
    "End At": "الانتهاء في",
    "Start": "البدء",
    "Not Started": "لم يبدأ",
    "Ended": "انتهى",
    "Score": "النتيجة",
    "Details": "التفاصيل",
    "Passed": "نجح",
    "Failed": "فشل",
    "Answer": "الإجابة",
    "Mark": "الدرجة",
    "Close": "إغلاق",
    "Messages": "الرسائل",
    "Find Courses": "العثور على دورات",
    "Preview this Course": "معاينة هذه الدورة",
    "Acquire global knowledge and build your \n professional skills": "اكتسب المعرفة العالمية وقم ببناء  \n مهاراتك المهنية",
    "Attach File": "إرفاق ملف",
    "Type your message...": "اكتب رسالتك...",
    "Join Group": "الانضمام إلى المجموعة",
    "You got {0}%": "لقد حصلت على {0}%",
    "Your score is {0}/{1}.": "نتيجتك هي {0}/{1}.",
    "You must get {0}% of correct answers to pass the quiz.": "يجب عليك الحصول على {0}% من الإجابات الصحيحة لاجتياز الاختبار.",
    "Keep Learning": "استمر في التعلم",
    "Best digital [Online] Courses": "أفضل الدورات الرقمية [عبر الإنترنت]",
    "Most demanding [Categories].": "الأكثر طلبًا [التصنيفات].",
    "Categories": "التصنيفات",
    "Top Categories": "أفضل التصنيفات",
    "Let Us Help": "دعنا نساعد",
    "Finding Your Right Courses": "العثور على الدورات المناسبة لك",
    "Get Started": "البدء",
    "Flexible classes": "فصول مرنة",
    "You pick schedule.": "أنت تختار الجدول الزمني.",
    "Offline mode": "وضع عدم الاتصال",
    "Download classes.": "تنزيل الفصول.",
    "10k online courses": "10 آلاف دورة عبر الإنترنت",
    "Explore a fresh topics": "استكشاف مواضيع جديدة",
    "Educator help": "مساعدة المدرب",
    "Always get answers.": "الحصول دائمًا على الإجابات.",
    "Our [Courses]": "قائمة [الدورات]",
    "Free": "مجاني",
    "Live Courses": "الدورات المباشرة",
    "Live": "مباشر",
    "Quiz": "اختبار",
    "Get Certificates": "الحصول على شهادات",
    "Create Certificate": "انشاء شهادة",
    "Live Students": "الطلاب المباشرين",
    "Join Now": "الانضمام الآن",
    "Teacher": "المعلم",
    "Courses Reviews": "مراجعات الدورات",
    "Student Say About [UNIX]": "يقول الطلاب عن [يونكس]",
    "Top [free] live Courses": "أفضل [مجانية] الدورات المباشرة",
    "Team": "الفريق",
    "Our Team": "فريقنا",
    "Get Started With [UNIX] Now": "ابدأ مع [يونكس] الآن",
    "Meet Our [Teachers]": "تعرف على [المعلمين] لدينا",
    "Enter your email and stay with us on activities.": "أدخل بريدك الإلكتروني وابق معنا على الأنشطة.",
    "Enter your email": "أدخل بريدك الإلكتروني",
    "Easy to Access": "سهل الوصول",
    "No Credit card": "بدون بطاقة ائتمان",
    "85,000 student onboard with us": "85,000 طالب معنا",
    "Subscribe!": "اشترك!",
    "About": "عنا",
    "Quick links": "روابط سريعة",
    "Our Newsletter": "تواصل معنا",
    "Got Questions? Call us": "هل لديك أسئلة؟ اتصل بنا",
    "Powered By": "تطوير",
    "All Courses": "جميع الدورات",
    "Grid": "شبكة",
    "List": "قائمة",
    "Hello": "أهلا",
    "Get Started With [UNIX]": "ابداء مع [يونكس]",
    "Short by": "تصنيف حسب",
    "Latest": "الأحدث",
    "Trending": "الشائع",
    "Category": "التصنيف",
    "Last Updated": "آخر تحديث",
    "Course Info": "معلومات الدورة",
    "Content": "المحتوى",
    "About Course": "عن الدورة",
    "Show More": "عرض المزيد",
    "Show Less": "عرض أقل",
    "Buy Course": "شراء الدورة",
    "30-Day Money-Back Guarantee": "ضمان استرداد الأموال خلال 30 يومًا",
    "Enroll Now": "التسجيل الآن",
    "Lectures": "المحاضرات",
    "Duration": "المدة الزمنية",
    "Certificate": "الشهادة",
    "Related Courses": "الدورات ذات الصلة",
    "This course includes:": "تتضمن هذه الدورة:",
    "Most Rated": "الأكثر تقييما",
    "Course Content": "محتوى الدورة",
    "Price: Low to High": "السعر: من الأقل إلى الأعلى",
    "Cancel": "إلغاء",
    "Audio List": "قائمة الصوت",
    "Text Content": "محتوى النص",
    "Preview": "معاينة",
    "Student Feedback": "تعليقات الطلاب",
    "Review the course": "مراجعة الدورة",
    "Show More Reviews": "عرض المزيد من المراجعات",
    "Loading...": "جار التحميل...",
    "Write a Review": "كتابة مراجعة",
    "Courses Found": "الدورات التي تم العثور عليها",
    "Review Content": "محتوى المراجعة",
    "Submit Review": "إرسال المراجعة",
    "No courses found": "لم يتم العثور على دورات",
    "What are you looking for?": "ما الذي تبحث عنه؟",
    "You have already written a review.": "لقد كتبت بالفعل مراجعة.",
    "What is it like to Course?": "كيف تبدو الدورة؟",
    "Help us improve our course material.": "ساعدنا على تحسين مواد الدورة.",
    "5 stars": "5 نجوم",
    "4 stars": "4 نجوم",
    "3 stars": "3 نجوم",
    "2 stars": "2 نجوم",
    "1 star": "1 نجمة",
    "Log In": "تسجيل دخول",
    "Sign in": "تسجيل الدخول",
    "Sign In": "دخول",
    "Contact Us": "اتصل بنا",
    "Courses": "الدورات",
    "Home": "الرئيسية",
    "Email": "البريد الإلكتروني",
    "Invalid login credentials": "بيانات تسجيل الدخول غير صحيحة",
    "Password": "كلمة المرور",
    "Save Account": "حفظ الحساب",
    "Forgot Password?": "هل نسيت كلمة السر؟",
    "Type your email": "اكتب بريدك الإلكتروني",
    "Don't have an account?": "ليس لديك حساب؟",
    "Create Now": "أنشئ الآن",
    "Student Applicant": "تسجيل طالب",
    "Rated {0} out of 5": "تم التقييم {0} من 5",
    "Video url not found": "لم يتم العثور على عنوان URL للفيديو",
    "Video file url not found": "لم يتم العثور على عنوان URL لملف الفيديو",
    "Your browser does not support the video tag.": "متصفحك لا يدعم علامة الفيديو.",
    "Search for Courses...": "البحث عن الدورات...",
    "We have the largest collection of {0} courses": "لدينا أكبر مجموعة من الدورات {0}",
    "© 2024 UNIX. All rights reserved.": "© 2024 يونكس. جميع الحقوق محفوظة.",
    "PDF file url not found": "لم يتم العثور علي ملف PDF",
    "Preview Certificate": "معاينة الشهادة",
    "Featured Reviews": "مراجعات مميزة",
    "No reviews found": "لم يتم العثور على مراجعات",
    'My Tickets': 'تذاكر الدعم',
    'Ticket ID': 'رقم التذكرة',
    'Ticket Subject': 'عنوان التذكرة',
    'Ticket Message': 'رسالة التذكرة',
    'Ticket Status': 'حالة التذكرة',
    'Ticket Created At': 'تم انشاء التذكرة في',
    'Ticket Updated At': 'تم تحديث التذكرة في',
    'Comments': 'التعليقات',
    'Comments ({0})': 'التعليقات ({0})',
    'No comments found': 'لم يتم العثور على تعليقات',
    'Add Comment': 'اضافة تعليق',
    'Add': 'اضافة',
    'New Comment': 'تعليق جديد',
    'In progress': 'قيد التنفيذ',
    'Closed': 'مغلق',
    'Open': 'مفتوح',
    'Ticket': 'تذكرة',
    'Escalated': 'تصاعد',
    'Waiting For Info': 'في انتظار المعلومات',
    'Waiting For Response': 'في انتظار الرد',
    'Ticket Type': 'نوع التذكرة',
    'New Ticket': 'تذكرة جديدة',
    'Ticket Name': 'اسم التذكرة',
    'Attach': 'رفع ملف',
    'Final Quiz': 'الاختبار النهائي',
}

export default ar;
